import packageJson from './../../package.json';

export default {
  appVersion: `v${packageJson.version}`,
}
